import './style.scss';

export function patients_hero_block() {
  const block = document.querySelector('.patients_hero_block');
  if (!block) return;
  
}
